import { render, staticRenderFns } from "./AdditionalHolidays_Edit.vue?vue&type=template&id=0a36708f&scoped=true"
import script from "./AdditionalHolidays_Edit.vue?vue&type=script&lang=js"
export * from "./AdditionalHolidays_Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36708f",
  null
  
)

export default component.exports